import { RefObject, useEffect } from 'react';

interface UseTranslateYOptions {
  ref: RefObject<HTMLElement>;
  shouldTranslate: boolean;
  yTransformValue: string;
  durationMs?: number;
}

export const useTranslateY = ({
  ref,
  shouldTranslate,
  yTransformValue,
  durationMs = 300
}: UseTranslateYOptions) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.backgroundColor = 'white';
    el.style.transition = `transform ${durationMs}ms ease-in-out`;
    el.style.transform = shouldTranslate ? `translateY(${yTransformValue})` : 'translateY(0)';
  }, [ref, shouldTranslate, yTransformValue, durationMs]);
};
